import React, { useState } from "react";
import * as XLSX from "xlsx";
import axios from "axios";
import {Navbar,Footer} from '../hrcomponents';
import configData from "../config.json";
import { format } from "date-fns";

const UploadExcel = () => {

    if(localStorage.getItem('branchID')===null){
        window.location.replace('/hris');
    }

    const [file, setFile] = useState(null);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setFile(file);

    const reader = new FileReader();

    reader.onload = (evt) => {
        try {

        const data = new Uint8Array(evt.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        const jsonData = XLSX.utils.sheet_to_json(sheet,{ raw: false });
        console.log(jsonData);

        setData(jsonData);
        } catch (err) {
        console.error("Error reading file:", err);
        }
    };
    reader.onerror = (err) => {
    console.error("FileReader error:", err);
    };
    reader.readAsArrayBuffer(file);

  };

  const handleUpload = async () => {
    if (!file) {
      alert("Please select file");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
        setLoading(true);
      const res = await axios.post(configData.SERVER_URL+`/uploadExceldata`, formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      alert("Upload successful!");
      console.log(res.data);
    } catch (err) {
      console.error(err);
      alert("Upload failed");
    } finally {
    setLoading(false); // ✅ stop loading
  }
  };

  

  const handleFileUpload = (e) => {
    const file = e.target.files[0];

    if (!file) {
    console.log("No file selected");
    return;
    }

    const reader = new FileReader();

    reader.onload = (evt) => {
        try {

        const data = new Uint8Array(evt.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        const jsonData = XLSX.utils.sheet_to_json(sheet);
        console.log(jsonData);

        setData(jsonData);
        } catch (err) {
        console.error("Error reading file:", err);
        }
    };

    reader.onerror = (err) => {
    console.error("FileReader error:", err);
    };
    reader.readAsArrayBuffer(file);
  };

//   const handleUploadToServer = async () => {
//     try {
//       let res = await axios.post(configData.SERVER_URL+`/uploadExceldata`, 
//         {data: data},
//         {headers: {'Content-Type': 'application/json'}}
//       );
//         console.log(res.status);
//         if(res.status===200){
//                 alert("Data inserted successfully!");
//         }
      
//     } catch (err) {
//       console.error(err);
//       alert("Error inserting data");
//     }
//   };

    const excelDateToJSDate  = (serial) => {
    return new Date((serial - 25569) * 86400 * 1000);
    };

    const excelTimeToString = (timeFraction) => {
    const totalSeconds = Math.round(timeFraction * 86400);

    const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
    const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
    const seconds = String(totalSeconds % 60).padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
    };

  return (
    <>
        <div className='container'>
        <Navbar/>

        <div className="row" style={{ padding: "20px" }}>
        <h2>Upload Excel File</h2>
        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            {/* <input type="file" className="btn btn-info" accept=".xlsx, .xls" onChange={handleFileUpload} /> */}
            <input type="file" className="btn btn-info" accept=".xlsx,.xls" onChange={handleFileChange} />
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <button className="btn btn-info" onClick={handleUpload} disabled={loading}>
                {loading ? <div className="spinner-border text-warning"></div> : "Upload to Database"}
            </button>
        </div>   
        </div>
        <hr></hr>

        <div className="row" style={{ padding: "20px" }}>  
        <h2>Preview:</h2><h5>(Record count {data.length})</h5>
        <table className="table table-info table-hover" border="1" cellPadding="5">
        <thead>
          <tr>
            <th>Emp Code</th>
            <th>Event Date</th>
            <th>Event Time</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              <td>{row.empCode}</td>
              <td>{row.eventDate}</td>
              <td>{row.eventTime}</td>
            </tr>
          ))}
        </tbody>
        </table>
        </div>
        
        <Footer/>
        </div>
        
    </>
  );
};

export default UploadExcel;